<template>
  <div class="py-5">
    <h4 class="pt-4 font-weight-normal">
      {{ $t('settings.security.title') }}
    </h4>
    <div class="mt-2 mb-2" style="min-height: 50px">
      <transition name="fade">
        <MenssageAlert :messages="messages" />
      </transition>
    </div>

    <Email @showMessage="showMessage" />

    <Password @passwordChanged="showMessage" />

    <Phone @showMessage="showMessage" @phoneConfirmed="cofirmPhoneNumber" />

    <TwoFactorAuthentication class="mt-5" @showMessage="showMessage" :phoneNumberConfirmed="phoneNumberConfirmed" />

    <DeleteAccount @showMessage="showMessage" />
  </div>
</template>

<script>
import Email from '../components/security/Email.vue'
import Password from '../components/security/Password.vue'
import Phone from '../components/security/Phone.vue'
import TwoFactorAuthentication from '../components/security/TwoFactorAuthentication.vue'
import DeleteAccount from '../components/security/DeleteAccount.vue'
import MenssageAlert from '@/components/MenssageAlert'

export default {
  components: {
    Email,
    Password,
    Phone,
    MenssageAlert,
    TwoFactorAuthentication,
    DeleteAccount,
  },
  data() {
    return {
      messages: [],
      phoneNumberConfirmed: undefined,
    }
  },
  methods: {
    cofirmPhoneNumber(confirmation) {
      this.phoneNumberConfirmed = confirmation
    },
    showMessage(message) {
      this.messages = []
      this.messages.push(message)
      this.scrollTop()
    },
    scrollTop() {
      setTimeout(() => {
        window.scrollTo(0, 0)
      }, 20)
    },
  },
}
</script>

<style>
.border-line {
  border-bottom: 2px solid #d1d4da;
}
</style>
